import {useBoolState} from "@/hooks";
import {useSynchronizeFaxMutation} from "./mutations.generated";
import {Dialog, Typography} from "@mui/material";
import {useState} from "react";
import {SynchronizeFaxResult} from "@/api";
import {DialogActions, DialogContent, FormattedButton, FormattedDialogTitle, TailSpin} from "@dvrt/graphql-widgets";
import {FormattedMessage, MessageDescriptor, defineMessage} from "react-intl";

type Props = {
    domainId: number;
    title: MessageDescriptor;
};

const SynchronizeButton = ({domainId, title}: Props) => {
    const [isOpen, setShowOn, setShowOff] = useBoolState();
    const [synchronizing, setSynchronizing] = useState(false);
    const [synchronizationResult, setSynchronizationResult] = useState<undefined | SynchronizeFaxResult>(undefined);

    const [synchronize] = useSynchronizeFaxMutation({
        variables: {
            domainId: domainId,
        },
        fetchPolicy: "no-cache",
    });

    const handleSynchronize = async () => {
        setShowOn();
        setSynchronizing(true);
        const result = await synchronize();
        setSynchronizationResult(result.data?.synchronizeFax);
        setSynchronizing(false);
    };

    return (
        <>
            <FormattedButton onClick={handleSynchronize} message={title} />
            <Dialog open={isOpen} onClose={setShowOff}>
                <FormattedDialogTitle
                    title={defineMessage({id: "fax_list.sync.title", defaultMessage: "Synchronize faxes"})}
                />
                <DialogContent>
                    {synchronizing && <TailSpin height={40} />}
                    {!synchronizing && (
                        <>
                            <Typography>
                                <FormattedMessage id="created" defaultMessage="Created" />:{" "}
                                {synchronizationResult?.created}
                            </Typography>
                            <Typography>
                                <FormattedMessage id="updated" defaultMessage="Updated" />:{" "}
                                {synchronizationResult?.updated}
                            </Typography>
                            <Typography>
                                <FormattedMessage id="deleted" defaultMessage="Deleted" />:{" "}
                                {synchronizationResult?.deleted}
                            </Typography>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <FormattedButton
                        message={defineMessage({id: "close", defaultMessage: "Close"})}
                        variant="text"
                        onClick={setShowOff}
                    />
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SynchronizeButton;
